import MainLayout from "../layout/MainLayout";
import Dashboard from "../pages/dashboard/dashboard";
import Feed from "../pages/Feed";

const UserRoutes = {
    path: "/",
    element: <MainLayout />,
    children: [
        {
            path: "/",
            element: <Dashboard />
        },
        {
            path: "/feed",
            element: <Feed />
        }
    ]
};

export default UserRoutes;